export default {
  computed: {
    getUrlName() {
      return "home"
    },
  },
}
